import { Dialog, DialogTitle, DialogContent, DialogActions, Button, Typography } from '@mui/material'
import { useTranslator } from '@/hooks/useTranslator'

interface IDialogConfirmProps {
  open: boolean
  onClose: () => void
  title: string
  content: string
  onConfirm: () => void
}

export const DialogConfirm = ({ open, onClose, title, content, onConfirm }: IDialogConfirmProps) => {
  const { __ } = useTranslator()

  return (
    <Dialog open={open} onClose={onClose} maxWidth='sm' fullWidth>
      <DialogTitle className='text-[18px] font-medium'>{title}</DialogTitle>
      <DialogContent>
        <Typography className='text-[15px] leading-[22px] text-[#2F2B3D99]'>{content}</Typography>
      </DialogContent>
      <DialogActions className='p-4'>
        <Button variant='outlined' onClick={onClose} className='rounded-full'>
          {__('Cancel')}
        </Button>
        <Button variant='contained' onClick={onConfirm} className='bg-[#FF4C51] text-white rounded-full' color='error'>
          {__('Delete')}
        </Button>
      </DialogActions>
    </Dialog>
  )
}
